export enum AdminRoute {
  ORACLE_VALIDATION = '/oracle-validation',
}
